// src/utils/exportTripsToExcel.js
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export function exportTripsToExcel(trips, filename = "trips_export.xlsx") {
  if (!trips || trips.length === 0) {
    alert("No data to export.");
    return;
  }

  const sheetData = trips.map((t) => ({
    Client: t.clientKey || "",
    "Client Trip ID": t.reservationId || "",
    "CLL Trip ID": t.cllTripId || "",
    Passenger: t.passengerName || "",
    Phone: t.passengerPhone || "",
    "No. of Pax": t.noOfPassengers || "",
    "Flight No": t.flightNumber || "",
    Pickup: t.pickup || "",
    Drop: t.drop || "",
    "Car Type": t.carType || "",
    Driver: t.driver || "",
    "Actual Parking": t.actualParking ?? "",
    "Client Parking": t.clientParking ?? "",
    "Driver Parking": t.driverParking ?? "",
    "Client Final Price": t.clientFinalPrice ?? "",
    "Driver Final Price": t.driverFinalPrice ?? "",
    "Total Client": t.totalClient ?? "",
    "Total Driver": t.totalDriver ?? "",
    Comments: t.comment ?? "",
    Status: t.parkingDone ? "Parking Done" : "Pending",
  }));

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(sheetData);
  XLSX.utils.book_append_sheet(wb, ws, "Trips");

  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([wbout], { type: "application/octet-stream" }), filename);
}
